import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class SpacesMapsEditLegacyRoute extends Route {
  @service router;

  beforeModel(transition) {
    const { floor_id } = transition.to.params;
    this.router.replaceWith('spaces.maps.edit.show', {
      queryParams: { floor_id },
    });
  }
}
